import { useMutation } from '@tanstack/react-query';
import { UsersApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useUsersControllerChangeUserRoleMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['usersControllerChangeUserRole', accessControlScope],
        mutationFn: async (args) => {
            const api = new UsersApi(accessControlConfig);
            return api.usersControllerChangeUserRole(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useUsersControllerChangeUserRoleMutation.js.map